module.exports = __webpack_public_path__ + "static/media/gs.175a61d9.svg";